module.exports = __webpack_public_path__ + "img/Sagittarius.48a3727a.svg";